module.exports = __webpack_public_path__ + "static/media/Team 13 - Eatup.0ceb01f4.png";